module.exports = __webpack_public_path__ + "static/media/logo-unilabs-le-pass.196c82da.svg";